import { createContext, useContext } from 'react';

/**
 * True inside the anchor column — the first cell after the `#` gutter.
 *
 * The anchor carries the row's identity and doubles as its click target, so it renders
 * `font-medium text-blue-500` where ordinary body copy is `text-slate-500`. Cell components
 * read this rather than every feature page passing a colour override, which would drift the
 * first time a page forgot to pass it.
 *
 * **Blue here is a deliberate exception to "a clickable thing is black".** Product call,
 * 14 Sep 2026, and it is scoped to the index surfaces: this context is provided only by
 * `<IndexTable>` and `<IndexListView>`, so an embedded `<DataTablePanel>` on a profile is
 * untouched, and links, breadcrumbs and menu rows stay `text-slate-800`.
 *
 * It is BELOW AA — 3.68:1 on white, 3.38:1 on a selected row, against slate-800's 14.63:1.
 * Accepted knowingly; `blue-600` (5.17:1) is the step to reach for if it has to clear the
 * bar. See the approved deviations table in CLAUDE.md.
 */
export const AnchorCellContext = createContext(false);

export function useAnchorCell(): boolean {
  return useContext(AnchorCellContext);
}
